import styled from '@emotion/styled'

export const Wrapper = styled.div`
  height: 100%;
  width: 100%;
`

export const ImageCenteredWrapper = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;

  .--with-placeholder > img {
    width: 105%;
  }
`
